import { ReusedApiAdapter } from '../adapters';
import { ReturnedReception } from '../models';

export class Service {
  constructor(private adapter: ReusedApiAdapter) {}

  async getPaginated(filters: any = {}) {
    const response = await this.adapter.getReceptions({
      search: filters.searchTerm,
      status: filters.status,
      page: filters.page,
      per_page: 15,
      order_by: filters.order_by || filters.sortBy || 'id',
      order_direction: filters.order_direction || filters.sortDirection || 'desc',
    });

    const reused: ReturnedReception[] = response.data || [];
    const total = response.meta?.total || 0;
    const currentPage = response.meta?.currentPage || 1;
    const lastPage = response.meta?.lastPage || 1;

    return {
      reused,
      total,
      currentPage,
      lastPage,
      nextPage: currentPage < lastPage ? currentPage + 1 : null,
    };
  }
}
